import { ApexOptions } from "apexcharts";

export const userPerformanceOptions: ApexOptions = {
  chart: {
    type: "bar",
    height: 350,
    id: "user-performances",
    toolbar: {
      show: false,
    },
  },
  plotOptions: {
    bar: {
      distributed: false,
      // dataLabels: {
      //   // position: "top",
      //   // orientation: "vertical",
      // },
      // rangeBarOverlap: true,
      // borderRadius: 4,
      horizontal: false,
      columnWidth: "44px",
    },
  },
  dataLabels: {
    enabled: true,
    formatter: (val) => `${val}`,
  },
  xaxis: {
    categories: [],
    labels: {
      style: {
        fontSize: "14px",
      },
    },
  },
  stroke: {
    show: false, // Hides the border
    width: 0,
  },
  yaxis: {
    labels: {
      show: true,

      style: {
        fontSize: "14px",
        colors: ["#333"], // Optional: label color
      },
    },
    title: {
      text: "Lead Count", // Optional: Y-axis title
      style: {
        fontSize: "14px",
        fontWeight: 400,
      },
    },
  },
  legend: {
    show: true,
  },
  grid: {
    show: false, // remove grid lines
  },
};
